module.exports = "/_next/static/images/sort-8758e4538c732af7a8634edb39a9b536.svg";